import { IRootState, RootState } from "../root-state.store";
import { ActivityStatus } from "../../common/enums";
import {
  IBMParameter, BMParameter,
  IBMDetailViewModel,
  IBMListingViewModel,
  IBMMeetingListingViewModel,
  BmDetailViewmodel, BMEditedViewModel
} from '../../models/bm';
import { BMService, IBMService } from "../../services";
import { IPagination, Pagination } from "../../models/generic";
import { BM_LOADERS } from "./bm-types.store";
import {IBMMeetingParameter, BMMeetingParameter} from "../../models/bm/bm-meeting.parameter";
import {BmMeetingDetailViewModel, IBMMeetingDetailViewModel} from "../../models/bm/bm-meeting-detail.viewmodel";
import {BMMeetingEditedViewModel} from "../../models/bm/bm-meeting-edited.viewmodel";
import {BMParticipantEditedViewModel} from "../../models/bm/bm-participant-edited.viewmodel";
import {BMIBEditedViewModel} from "../../models/bm/bm-ib-edited.viewmodel";
import {BMPlanEditedViewModel} from "../../models/bm/bm-plan-edited.viewmodel";
import {BMContractorEditedViewModel} from "../../models/bm/bm-contractor-edited.viewmodel";
import {BMCommentEditedViewModel} from "../../models/bm/bm-comment-edited.viewmodel";
import {BMMarkerEditedViewModel} from "../../models/bm/bm-marker-edited.viewmodel";

export interface IBMState extends IRootState {
  bmParameter?: IBMParameter;
  bmMeetingParameter?: IBMMeetingParameter;
  pagination?: IPagination;
  bmSource?: {
    activityStatus: ActivityStatus;
    detail: IBMDetailViewModel
  };
  bmsSource?: {
    activityStatus: ActivityStatus;
    data?: IBMListingViewModel[]
  };
  bmEdited?: BMEditedViewModel;
  bmParticipantEdited?: BMParticipantEditedViewModel;
  bmMeetingEdited?: BMMeetingEditedViewModel;
  bmIBEdited?: BMIBEditedViewModel;
  bmPlanEdited?: BMPlanEditedViewModel;
  bmContractorEdited?: BMContractorEditedViewModel;
  bmCommentEdited?: BMCommentEditedViewModel;
  bmMarkerEdited?: BMMarkerEditedViewModel;
  bmCurrent?: IBMListingViewModel;
  bmMeetings?: {
    activityStatus: ActivityStatus;
    data?: IBMMeetingListingViewModel[]
  };
  bmMeeting?: {
    activityStatus: ActivityStatus;
    data?: IBMMeetingDetailViewModel
  },
  bmMeetingPlan?: any[]
}
export class BMState extends RootState<IBMService> implements IBMState {
  /**
   *
   */
  bmParameter?: IBMParameter;
  bmMeetingParameter?: IBMMeetingParameter;
  bmSource: {
    activityStatus: ActivityStatus;
    detail: IBMDetailViewModel
  }
  bmsSource: {
    activityStatus: ActivityStatus;
    data: IBMListingViewModel[]
  }
  bmEdited?: BMEditedViewModel;
  bmParticipantEdited?: BMParticipantEditedViewModel;
  bmMeetingEdited?: BMMeetingEditedViewModel;
  bmIBEdited?: BMIBEditedViewModel;
  bmPlanEdited?: BMPlanEditedViewModel;
  bmContractorEdited?: BMContractorEditedViewModel;
  bmCommentEdited?: BMCommentEditedViewModel;
  bmMarkerEdited?: BMMarkerEditedViewModel;
  bmCurrent?: IBMListingViewModel;
  pagination?: IPagination;
  bmMeetings?: {
    activityStatus: ActivityStatus;
    data?: IBMMeetingListingViewModel[]
  }
  bmMeeting?: {
    activityStatus: ActivityStatus;
    data?: IBMMeetingDetailViewModel
  }
  bmMeetingPlan?: any[]
  constructor() {
    super({
      activityStatus: ActivityStatus.NoActivity,
      service: new BMService
    });
    this.pagination = new Pagination({ limit: 0, skip: 0, total: 0 })
    this.bmParameter = new BMParameter();
    this.bmMeetingParameter = new BMMeetingParameter();
    this.bmMeetings = {
      activityStatus: ActivityStatus.NoActivity,
      data: []
    }
    this.bmSource = {
      activityStatus: ActivityStatus.NoActivity,
      detail: new BmDetailViewmodel
    }
    this.bmsSource = {
      activityStatus: ActivityStatus.NoActivity,
      data: []
    }
    this.bmCurrent = null
    this.bmEdited = {fk_block: null, fk_apartment: null, date_start_building: null, date_end_building: null}
    this.bmParticipantEdited = new BMParticipantEditedViewModel()
    this.bmIBEdited = new BMIBEditedViewModel()
    this.bmPlanEdited = new BMPlanEditedViewModel()
    this.bmContractorEdited = new BMContractorEditedViewModel()
    this.bmCommentEdited = new BMCommentEditedViewModel()
    this.bmMarkerEdited = new BMMarkerEditedViewModel()
    this.bmMeetingEdited = {
      date_start: null,
      date_end: null,
      date_next_meeting: null,
      lastMeetingId: null,
      sendNextMeeting: false
    }
    this.bmMeetings = {
      activityStatus: ActivityStatus.NoActivity,
      data: []
    }
    this.bmMeeting = {
      activityStatus: ActivityStatus.NoActivity,
      data: new BmMeetingDetailViewModel()
    }
    this.bmMeetingPlan = []
    this.loaders= new Map([
      [BM_LOADERS.LIST,false],
      [BM_LOADERS.FILTERS,false],
      [BM_LOADERS.SIDEBAR,false],
      [BM_LOADERS.DETAILS,false]
    ])
  }
}



// WEBPACK FOOTER //
// ./src/store/building-monitor/bm-state.store.ts